import { 
    useLocation
 } from "react-router-dom";

const useQueryString = (name) => {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(useLocation().search);
    if (results == null){
       return null;
    }
    else {
       return decodeURI(results[1]) || 0;
    }
}

 export default useQueryString